import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function InsuranceCaptivesIsleMan() {

    return (
        <main className='main'>

            <IntroSection
                title="Insurance & Captives – Isle of Man"
                subtitle="A Global Hub for Captive, General & Life Insurance"
                description="
                The <b>Isle of Man</b> is a <b>premier jurisdiction</b> for <b>insurance and reinsurance licensing</b>, offering a <b>strong, English common-law framework</b> with <b>international credibility</b>.
                <br/>
                The <b>IOMFSA</b> regulates all <b>insurance entities</b>, ensuring <b>compliance with Solvency II-equivalent standards</b> and <b>global best practices</b>. The jurisdiction is especially attractive for <b>multinationals</b>, <b>financial institutions</b>, and <b>shipping/aviation companies</b> looking for <b>captive insurance solutions</b>.

                "
                badges={
                    [
                        "Captive Insurance",
                        "General Insurance",
                        "Life Insurance",
                        "Reinsurance"
                    ]
                }
                buttonText="Request an Isle of Man Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/insurance-captives-isle-man-hero.png")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Isle of Man for Insurance?'
                        blocks={
                            [
                                {
                                    items: [
                                        {
                                            title: "Tier-1 Reputation",
                                            text: "Recognized worldwide."
                                        },
                                        {
                                            title: "Strong Regulator",
                                            text: "IOMFSA enforces solvency and compliance."
                                        },
                                        {
                                            title: "Captive Expertise",
                                            text: "Decades of experience in self-insurance models."
                                        },
                                        {
                                            title: "Tax Benefits",
                                            text: "0% corporate tax (except local banking and land)."
                                        },
                                        {
                                            title: "Investor & Market Confidence",
                                            text: "Attracts global reinsurers and corporates."
                                        }
                                    ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Insurance Licenses in the Isle of Man"
                        blocks={
                            [
                                {
                                    title: "Captive Insurance License",
                                    items:
                                        [
                                            {
                                                title: "Captive Insurance",
                                                text: "Used by corporations to self-insure group risks."
                                            },
                                            {
                                                title: "Industry Use",
                                                text: "Popular in aviation, shipping, finance, and energy sectors."
                                            }
                                        ]
                                },
                                {
                                    title: "General Insurance License",
                                    items: [
                                        {
                                            title: "Non-Life Insurance",
                                            text: "Covers property, liability, casualty, and specialty risks."
                                        },
                                        {
                                            title: "Underwriting Scope",
                                            text: "Allows underwriting of both domestic and international risks."
                                        }
                                    ]
                                },
                                {
                                    title: "Life Insurance License",
                                    items: [
                                        {
                                            title: "Life Insurance",
                                            text: "For providers of life, health, annuities, and pensions."
                                        },
                                        {
                                            title: "Regulatory Requirements",
                                            text: "Requires strong actuarial and solvency frameworks."
                                        }
                                    ]
                                },
                                {
                                    title: "Reinsurance License",
                                    items:
                                        [
                                            {
                                                title: "Reinsurance Support",
                                                text: "Supports global reinsurance businesses."
                                            },
                                            {
                                                title: "International Recognition",
                                                text: "IoM is recognized by international regulators and counterparties."
                                            }
                                        ]
                                },

                            ]
                        }
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Captives",
                                    text: "GBP 100,000 minimum."
                                },
                                {
                                    title: "General Insurance",
                                    text: "GBP 250,000+ minimum capital requirement."
                                },
                                {
                                    title: "Life Insurance",
                                    text: "GBP 350,000+ minimum capital requirement."
                                },
                                {
                                    title: "Reinsurance",
                                    text: "GBP 500,000+ minimum capital requirement."
                                },
                                {
                                    title: "Entity Requirement",
                                    text: "IoM-incorporated company required."
                                },
                                {
                                    title: "Resident Presence",
                                    text: "At least 2 local directors and a compliance officer."
                                },
                                {
                                    title: "Compliance",
                                    text: "Full AML/KYC and solvency reporting."
                                },
                                {
                                    title: "Audit",
                                    text: "Annual audited financial statements required."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of Isle of Man Insurance License'
                        services={
                            [
                                {
                                    title: "Credibility",
                                    text: "Higher prestige than Seychelles, SVG, or Mwali."
                                },
                                {
                                    title: "Global Standards",
                                    text: "Solvency II-aligned regulatory framework."
                                },
                                {
                                    title: "Captive-Friendly",
                                    text: "Widely used by Fortune 500 companies."
                                },
                                {
                                    title: "Investor Confidence",
                                    text: "Institutions prefer IoM captives."
                                },
                                {
                                    title: "Cost Advantage vs Bermuda",
                                    text: "Similar credibility with lower setup and maintenance costs."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Choose the appropriate insurance or reinsurance license type."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Register an Isle of Man company."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Prepare actuarial studies, compliance manuals, and business plan."
                                },
                                {
                                    title: "IOMFSA Review",
                                    text: "Regulator conducts due diligence on shareholders, directors, and compliance."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically takes 6–12 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "6–12 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from GBP 75,000+."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "GBP 100k–500k depending on license."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "compliance, audits, IOMFSA fees."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Specialists in insurance & captive licensing worldwide."
                                },
                                {
                                    text: "End-to-end support: incorporation, actuarial filings, IOMFSA approvals."
                                },
                                {
                                    text: "Network of reinsurers, actuaries, and compliance officers."
                                },
                                {
                                    text: "Comparative insights: IoM vs Bermuda vs Cayman vs Guernsey."
                                },
                                {
                                    text: "Ongoing compliance and reporting support."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to establish a captive, insurer, or reinsurance company?"
                        description="The Isle of Man offers Tier-1 insurance licenses under IOMFSA, trusted worldwide."
                        buttonText="Book an Isle of Man Insurance Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Why IoM instead of Bermuda or Cayman?",
        content: [
            { type: "answer", text: "IoM offers similar credibility at lower cost and faster approvals." },
        ],
    },
    {
        question: "Do IoM insurers follow Solvency II?",
        content: [
            { type: "answer", text: "Yes — IoM is Solvency II-equivalent, aligned with EU standards." },
        ],
    },
    {
        question: "How much capital is required?",
        content: [
            { type: "answer", text: "GBP 100k–500k depending on license type." },
        ],
    },
    {
        question: "Can multinationals establish captives in IoM?",
        content: [
            { type: "answer", text: "Yes — IoM is one of the leading global captive hubs." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–12 months." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We set up a captive in the Isle of Man to insure group risks. Offshore Advisory made the process seamless.",
        author: "Richard L.",
        role: "Aviation CFO"
    },
    {
        quote: "The IoM was the right choice for our reinsurance vehicle. Offshore Advisory handled the regulatory approvals.",
        author: "Laura G.",
        role: "Insurance Director"
    }
];


